import SendMeResultsButton from './SendMeResultsButton';

export default SendMeResultsButton;
